import {
  API_HOST,
  API_HOST_JAVA,
  API_IMG_HOST,
  DHT_HOST_API
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import VueAxios from 'vue-axios'
const axiosJava1 = axios.create({
  baseURL: API_HOST_JAVA,
  headers: {
    'token': '40F61D43AEAE8474E80ACC0D68168E89ACD12344C5C7FD472ECCEE966644588E273720671EFD4AAA723207576886B27B946271785C16AD86D97F71A02C87EED6',
    'app_key': 'jyjxs',
    'appVersion': '100683',
    'timestamp': '1539306308809',
    'sign': 'C7E471D17611F478FA9A897328C2AFDC',
    'Content-Type': 'application/json'
  }
})
axiosJava1.defaults.timeout = 1000 * 15
axiosJava1.defaults.headers['Content-Type'] = 'application/json'

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}
// 返回处理
axiosJava1.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code === -1) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('userInfo')
    Lockr.rm('firstRoutePath')
    // 跳转到登录页
    // router.push({path: '/login'})
    return response
  } else if (response.data.code > 101) {
    // _g.toastMsg('error', response.data.error)
    return response
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})

// 根据更新日志过滤系统产品列表
export function getUpdateLogList (arr) {
  let url = DHT_HOST_API + '/system/versionUpdateLog/getUserSysProduct'
  return axiosJava1.post(url,  arr)
}
export function getUpdateLogNew (page, limit,code) {
  let url = DHT_HOST_API + '/system/versionUpdateLog/getListByPage'
  // axiosJava1.defaults.headers.appKey = 'jyjxs'
  // axiosJava1.defaults.headers.appVersion = '100683'
  // axiosJava1.defaults.headers.timestamp =  '1539306308809'
  // axiosJava1.defaults.headers.sign = 'C7E471D17611F478FA9A897328C2AFDC'
  // axiosJava1.defaults.headers.token = '40F61D43AEAE8474E80ACC0D68168E89ACD12344C5C7FD472ECCEE966644588E273720671EFD4AAA723207576886B27B946271785C16AD86D97F71A02C87EED6'

  return axiosJava1.get(url, {
    params: {
      sysCode: code,
      page: page,
      limit: limit,
      app_key: 'jyjxs',
      appVersion: '100683',
      status: 1,
      timestamp: '1539306308809',
      sign: 'C7E471D17611F478FA9A897328C2AFDC',
      updateKeyword: '',
      versionStartDate: '',
      token: '40F61D43AEAE8474E80ACC0D68168E89ACD12344C5C7FD472ECCEE966644588E273720671EFD4AAA723207576886B27B946271785C16AD86D97F71A02C87EED6',
    }
  })
}






